import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}categories-product`;

// const token = localStorage.getItem('token');


export const getProductsCategories = () => {
    const token = localStorage.getItem('token');

    return axios.get(API_URL_WEB, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getProductCategoriesById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const createProductCategories = (productDetail) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL_WEB, productDetail, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateProductCategories = (id, productDetail) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/${id}`, productDetail, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const deleteProductCategories = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    })
}

// findByIdProduct

export const findCategoriesByIdProduct = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/findByIdProduct/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const categoriesProducIitem = (row) => {
    const token = localStorage.getItem('token');

    return axios.post(`${API_URL_WEB}/categories-product/categories-product-item`, row, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}